export default __webpack_public_path__ + "static/media/image-10.4daa480f.gif";